
import { useEffect, useMemo, useState } from "react";
import { Column } from "react-table";
import { useDeleteFixedDiscountRules, useRefundRules } from "../hooks";
import { Link } from "@funcional/react-ui";
import { useHistory, useParams } from "react-router-dom";
import { Grid } from '@material-ui/core'
import { TextField, Button } from '@funcional/react-ui'
import { useRef } from 'react'
import { GridView } from "@funcional/react-table-ui";
import { formatDate } from "@refund/helpers";
import { IRefundRule, IRuleProduct } from "../contracts";

export interface searchParams {
  product?: string;
}
const containerSpacing = 3;

function getURLParameters(params: string): searchParams {
  var searchParams = new URLSearchParams(params);
  var result = {} as searchParams;

  for (var param of Array.from(searchParams)) {
    var key = decodeURIComponent(param[0]);
    var value = decodeURIComponent(param[1]);
    if (result[key]) {
      if (Array.isArray(result[key])) {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  }
  return result;
}


export function QueryRulesForm({ props }: { props?: undefined }): JSX.Element {
  const { params }: { params: string } = useParams();
  const urlParameters = getURLParameters(params)

  const product = useRef('');
  const history = useHistory();

  const [showElement, setShowElement] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowElement(true);
    }, 100);

    return () => clearTimeout(timeout);

  }, [showElement]);

  const onChange = (event) => {
    product.current = event.target.value;
  }
  const showRecord = (row: any) =>
    history.push(`/refund/fixed-discount-rule/view/${row.original.rulesId}`);
  const editRecord = (row: any) =>
    history.push(`/refund/fixed-discount-rule/edit/${row.original.rulesId}`);

  const { mutateAsync } = useDeleteFixedDiscountRules();
  const deleteRecord = async (row: any) => {
    if (!window.confirm("Tem certeza de que deseja excluir este registro?")) {
      return Promise.resolve(false);
    }
    try {
      await mutateAsync({
        refundRulesId: row.original.id,
      });
      return true;
    } catch (err) {
      window.alert('Ocorreu um erro ao tentar excluir o registro, tente novamente mais tarde. Caso o problema persista, entre em contato com o administrador do sistema.')
      console.error(err);
      return false;
    }
  };

  const columns: Column<IRefundRule>[] = useMemo(
    () => [
      {
        Header: "ID Regra",
        accessor: "rulesId",
        Cell: ({ value }) => <Link to={`/refund/fixed-discount-rule/view/${value}`}>{value}</Link>,
      },
      {
        Header: "Produto",
        accessor: "product",
        Cell: ({ value }: { value: IRuleProduct }) => {
          return value?.name || null
        }
      },
      {
        Header: "Descrição do produto",
        accessor: "product",
        id: "product_description",
        Cell: ({ value }: { value: IRuleProduct }) => {
          return value?.description || null
        },
      },
      {
        Header: "Criado em",
        accessor: "createdAt",
        Cell: ({ value }: any) => {
          return formatDate(value)
        },
      },
      {
        Header: "Última atualização",
        accessor: "updatedAt",
        Cell: ({ row }: any) => {
          return (row.original.createdAt === row.original.updatedAt) ?
            '-' : formatDate(row.original.updatedAt)
        },
      },
    ],
    []
  );

  return (
    <Grid container spacing={containerSpacing}>
      <Grid item xs={3}>
        <TextField
          required
          type="text"
          id="product"
          label="Produto"
          onChange={onChange}
          defaultValue={urlParameters.product}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (product.current.length > 0) {
                history.push(`/refund/fixed-discount-rule/product=${product.current}`)
              } else {
                history.push(`/refund/fixed-discount-rule/`)
              }
              setShowElement(false)
            }
          }}
        />
      </Grid>

      <Grid item xs={3}>
        <Button
          color="primary"
          onClick={() => {
            if (product.current.length > 0) {
              history.push(`/refund/fixed-discount-rule/product=${product.current}`)
            } else {
              history.push(`/refund/fixed-discount-rule/`)
            }
            setShowElement(false)
          }}
        >
          Buscar Regras
        </Button>
      </Grid>

      {urlParameters.product && showElement ?
        <Grid item xs={12}>
          <GridView<IRefundRule>
            accessControlResourceName="query-fixed-discount-rules"
            paginationType="cursor"
            paginas
            paginated
            columns={columns}
            hook={useRefundRules}
            showRecord={showRecord}
            editRecord={editRecord}
            deleteRecord={deleteRecord}
            defaultFilters={[{ id: "productName", value: urlParameters.product }]}
          />
        </Grid>
        : <></>
      }

    </Grid>
  );
}
